const styles = {
    show: {
        display: "block"
    },
    hide: {
        display: "none"
    }
}

export default styles;